// The onboarding and SLA APIs anchor every write to the version the client last read: a quoted
// If-Match, answered 412 when stale. One home for the header so the quoting cannot drift.
export function ifMatch(version: number): { 'If-Match': string } {
    return { 'If-Match': `"${version}"` };
}
